<app-page-heading [title]="'Users'"></app-page-heading>

<section class="container-fluid summary-panel">
    <div class="row">
        <div class="col-xs-12">
            <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateUser()">
                <span class="fa fa-plus"></span> Create User
            </button>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table [loadPage]="loadPage" [showCarrier]="true" (edit)="goToEditUser($event)"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
